import React from "react";
import { issueDistribution } from "../../data/findings";
export function IssueDistribution() {
  const max = Math.max(...issueDistribution.map(c => c.share));
  return <ol className="border-t border-stone" data-id="element-487" data-mp="1ugdpoge3ay5j">
      {issueDistribution.map((c, i) => <li key={c.name} className="grid grid-cols-12 items-center gap-x-4 gap-y-2 border-b border-stone py-4" data-id="element-488" data-mp="1uej02orvihv4" data-mpi={i}>
          <span className="col-span-12 text-sm text-charcoal sm:col-span-5" data-id="element-489" data-mp="2n51cigehlvl7">{c.name}</span>
          <span className="relative col-span-10 block h-3 sm:col-span-6" aria-hidden data-id="element-490" data-mp="2n36ogt7x5ncw">
            <span className={`absolute inset-y-0 left-0 ${i === 0 ? "bg-oxblood" : "bg-navy"}`} style={{
          width: `${c.share / max * 100}%`
        }} data-id="element-491" data-mp="2s21i6q7fcwbs" />
          </span>
          <span className="col-span-2 text-right font-display text-xl tabular-nums text-navy sm:col-span-1" data-id="element-492" data-mp="2i814hzy2uirg">
            {c.share}%
          </span>
        </li>)}
    </ol>;
}